import React, { ReactElement } from 'react';

import styled from 'styled-components';

import { Text, Title } from 'chime-ui/components/Typography';

import ErrorGeneric from './Generic';

function MaintenanceMessage(): ReactElement {
  return (
    <ErrorGeneric>
      <ContentLayout>
        <Title size={'small'}>Currently under maintenance</Title>
        <Text size={'standard'}>
          We are working on making your experience better. Please try again
          later or contact our Member Services team if you need more support.
        </Text>
      </ContentLayout>
    </ErrorGeneric>
  );
}

const ContentLayout = styled.div`
  display: grid;
  row-gap: 0.5rem;
`;

export default MaintenanceMessage;
